import { render, staticRenderFns } from "./FsCell.vue?vue&type=template&id=65b8b74d&"
import script from "./FsCell.vue?vue&type=script&lang=js&"
export * from "./FsCell.vue?vue&type=script&lang=js&"
import style0 from "./FsCell.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports